import type { OnboardingTourStepOption } from 'models';
import { useEffect } from 'react';

const NoSupportedStep = ({
  onChangeStep,
}: {
  onChangeStep: (options: { replace?: boolean; step: OnboardingTourStepOption }) => void;
}) => {
  useEffect(() => {
    onChangeStep({ replace: true, step: 'intro' });
  }, [onChangeStep]);

  return null;
};

export default NoSupportedStep;
